// extracted by mini-css-extract-plugin
export default {"social_login":"SocialLogin_social_login__Ze6PK","social_btn":"SocialLogin_social_btn__HU-gf"};